import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import useFeature from 'hooks/useFeature';
import { selectPrequalOffer } from 'state/prequalOffer';
import { FeatureGroups } from 'state/tenant';
import { Step, Workflow } from './Workflow';
import useResponsiveQuery from 'hooks/useResponsiveQuery';
import useQueryParameters from 'hooks/useQueryParameters';
import { keys, not, reject } from 'ramda';

const usePrequalTokenLookupWorkflow = () => {
  const { isGroupEnabled } = useFeature();
  const { prequalificationId, hasOffer } = useSelector(selectPrequalOffer);
  const { isMobile } = useResponsiveQuery();
  const { selectedCardKey } = useQueryParameters();
  const { isEnabled } = useFeature();

  const getWorkflow = useCallback((): Workflow => {
    const stepsEnabled = {
      [Step.CARD_SELECTOR]: isEnabled('cardSelector') && !selectedCardKey,
      [Step.CONSUMER_SEARCH]: true,
      [Step.PREQUAL_OFFER_APPLICATION]: true,
      [Step.APPLICATION]: true,
      [Step.APPLICATION_2]: !prequalificationId && !hasOffer && isMobile,
      [Step.ADD_ONS]: isGroupEnabled(FeatureGroups['add-ons']),
      [Step.REVIEW_TERMS]: true,
    };
    const firstStep = ((keys(
      reject(not, stepsEnabled),
    ) as unknown) as Step[])[0];
    return {
      stepsEnabled: stepsEnabled,
      paths: {
        [Step.CARD_SELECTOR]: '/card-selector',
        [Step.CONSUMER_SEARCH]: '/prequal/consumer-search',
        [Step.PREQUAL_OFFER_APPLICATION]: '/prequal/offer-application',
        [Step.APPLICATION]: '/prequal/application',
        [Step.ADD_ONS]: '/add-ons',
        [Step.REVIEW_TERMS]: '/prequal/review-terms',
        ...{
          [firstStep]: '/prequal/token-lookup',
        },
      },
      progressStartStep: Step.PREQUAL_OFFER_APPLICATION,
      restartStep: firstStep,
      timeoutRestartPath: '/prequal/token-lookup',
    };
  }, [
    hasOffer,
    isEnabled,
    isGroupEnabled,
    isMobile,
    prequalificationId,
    selectedCardKey,
  ]);

  return getWorkflow;
};

export default usePrequalTokenLookupWorkflow;
